import { __assign, __rest } from "tslib";
import React from 'react';
import SystemNotification from '../../SystemNotification';
import ErrorBoundary from '../../ErrorBoundary';
import { useFlag } from '../../redux/flags/hooks/useFlag';
import { useDismissableNotification } from './useDismissableNotification';
var durations = {
    XS: 2000,
    S: 2500,
    M: 6000,
    XL: 10000,
};
function getDuration(isMultiline, actionCount) {
    if (isMultiline === void 0) { isMultiline = false; }
    if (actionCount === void 0) { actionCount = 0; }
    if (!isMultiline) {
        if (!actionCount) {
            return durations.XS;
        }
        if (actionCount === 1) {
            return durations.S;
        }
        return durations.M;
    }
    return durations.XL;
}
var Notification = function (_a) {
    var id = _a.id, removeNotification = _a.removeNotification, onCloseCallback = _a.onClose, queueName = _a.queueName, notifProps = __rest(_a, ["id", "removeNotification", "onClose", "queueName"]);
    var immortalNotifications = useFlag('yumeruby');
    var _b = useDismissableNotification({
        id: id,
        queueName: queueName,
        duration: immortalNotifications
            ? 9999999
            : getDuration(notifProps.multiLine, notifProps.actions && notifProps.actions.length),
        removeNotification: removeNotification,
        onCloseCallback: onCloseCallback,
    }), onClose = _b.onClose, onPause = _b.onPause, onUnpause = _b.onUnpause;
    return (React.createElement(ErrorBoundary, null,
        React.createElement(SystemNotification, __assign({}, notifProps, { onClose: onClose, onMouseEnter: onPause, onMouseLeave: onUnpause }))));
};
Notification.displayName = 'Notification';
export default Notification;
//# sourceMappingURL=Notification.fave_comment_tooltip.js.map